module.exports = __webpack_public_path__ + "images/ami.f61ba49848e76360fe70a20c68e6fe82.png";